import config from "./config";
import firebaseConfig from "./firebase";

export default {
  ...config,
  firebase: firebaseConfig,
};
